import Client from "./Client";
import Coupon from "Class/Coupon";
import { AnyObject } from "types";

const resource = "/coupons";

export default class CouponService {
  public static async listAllCoupons(
    page: number,
    page_size: number
  ): Promise<AnyObject> {
    let url = `${resource}`;
    if (page !== 0 && page_size !== 0)
      url = `${resource}?page=${page}&page_size=${page_size}`;
    const { data } = await Client.get(url);
    return data;
  }

  public static async searchCoupon(code: string): Promise<Coupon> {
    const { data } = await Client.get(`${resource}/search/${code}`);
    return new Coupon(data.data);
  }

  public static async getCoupon(couponId: number): Promise<Coupon> {
    const { data } = await Client.get(`${resource}/${couponId}`);
    const comp = new Coupon(data.data);
    return comp;
  }

  public static async createCoupon(coupon: Coupon): Promise<AnyObject> {
    const { data } = await Client.post(`${resource}`, coupon.asJSON());
    return data;
  }

  public static async updateCoupon(coupon: Coupon): Promise<AnyObject> {
    const { data } = await Client.put(
      `${resource}/${coupon.id}`,
      coupon.asJSON()
    );
    return data;
  }

  public static async removeCoupon(couponId: number): Promise<AnyObject> {
    const { data } = await Client.delete(`${resource}/${couponId}`);
    return data;
  }
}
